/** @jsx jsx */
import { jsx } from 'theme-ui'

export const Dash = ({ color = 'primary', ...rest }) => (
  <svg viewBox="0 0 48 24" sx={{ width: '2em', height: '1em' }} {...rest}>
    <line x1="0" y1="6" x2="48" y2="18" sx={{ stroke: color }} />
  </svg>
)
